import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import styled from "styled-components";
// import { useMediaQuery } from "@mui/material";

import { getAnalytics } from "../../redux/slices/dashboardSlice";
import { useDispatch, useSelector } from "react-redux";

const Linechart = () => {
  // const isTab = useMediaQuery("(max-width:867px)");
  // const isMobile = useMediaQuery("(max-width:567px)");
const dispatch = useDispatch();
const {analytics} = useSelector((state) => state.dashboard);

const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const years = [];
  for (let i = currentYear; i >= 2020; i--) {
    years.push(i);
  }

useEffect(() => {
  dispatch(getAnalytics({year}));
  },[dispatch, year]);
  //console.log(analytics)

  const handleYear = (event) => {
    const selectedYear = Number(event.target.value);
    setYear(selectedYear);
  };

  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  // Transforming the API data
  const data =
    analytics && analytics.camapigns
      ? analytics.camapigns.map((campaign, index) => ({
          name: monthNames[index], // Month name
          Advertisers: analytics.advertisers.advertiser[index]?.advertiserCount || 0,
          Campaigns: campaign.campaignCount || 0,
          Conversions: analytics.conversions.conversions[index]?.conversioncount || 0,
        }))
      : [];
  // Dummy data
  // const data = [
  //   { name: "Jan", Advertisers: 200, Campaigns: 400, Conversions: 600 },
  //   { name: "Feb", Advertisers: 260, Campaigns: 420, Conversions: 520 },
  //   { name: "Mar", Advertisers: 230, Campaigns: 390, Conversions: 530 },
  //   { name: "Apr", Advertisers: 280, Campaigns: 350, Conversions: 650 },
  //   { name: "May", Advertisers: 260, Campaigns: 360, Conversions: 560 },
  //   { name: "Jun", Advertisers: 270, Campaigns: 440, Conversions: 670 },
  //   { name: "Jul", Advertisers: 290, Campaigns: 390, Conversions: 690 },
  //   { name: "Aug", Advertisers: 270, Campaigns: 400, Conversions: 600 },
  //   { name: "Sep", Advertisers: 320, Campaigns: 420, Conversions: 620 },
  //   { name: "Oct", Advertisers: 340, Campaigns: 440, Conversions: 540 },
  //   { name: "Nov", Advertisers: 360, Campaigns: 480, Conversions: 660 },
  //   { name: "Dec", Advertisers: 320, Campaigns: 390, Conversions: 680 }
  // ];

  const formatCurrency = (tick) => {
    if (tick >= 1000000) return `${tick / 1000000}m`;
    if (tick >= 1000) return `${tick / 1000}k`;
    return tick;
  };

  return (
    <div style={{ marginLeft: "-30px", marginTop: "30px" }}>
      <Header>
        <div></div>
        <div>
        <select className="see-more2" value={year} onChange={handleYear}>
              <option value="" disabled>Select Year</option>
              {years.map((yearOption) => (
                <option key={yearOption} value={yearOption}>
                  {yearOption}
                </option>
              ))}
            </select>
        </div>
      </Header>
      <ResponsiveContainer width="100%" height={334}>
        <BarChart
          data={data}
          margin={{ top: 20, right: 20, left: 0, bottom: 0 }}
          barSize={32}
        >
          {/* Gradient definition for each area */}
          {/* <defs>
            <linearGradient id="AdvertisersGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#00A087" stopOpacity={0.2} />
              <stop offset="100%" stopColor="#ffffff" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="CampaignsGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#00A087" stopOpacity={0.2} />
              <stop offset="100%" stopColor="#ffffff" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="ConversionsGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#00A087" stopOpacity={0.2} />
              <stop offset="100%" stopColor="#ffffff" stopOpacity={0} />
            </linearGradient>
          </defs> */}

          <CartesianGrid vertical={false} stroke="#e3f2fd" />
          <XAxis
            dataKey="name"
            stroke="#90a4ae"
            fontSize={10}
            fontWeight={300}
            minTickGap={1}
            axisLine={false}
            tickLine={false}
          />
          {/* Left Y-axis for Advertisers and Campaigns */}
          <YAxis
            yAxisId="left"
            stroke="#90a4ae"
            fontSize={10}
            fontWeight={300}
            minTickGap={1}
            tickFormatter={formatCurrency}
            axisLine={false}
            tickLine={false}
            label={{
              value: "Advertisers, Campaigns",
              angle: -90,
              position: "inside",
              style: { fill: "#90a4ae", fontSize: 11, fontWeight: 500 },
            }}
          />
          {/* Right Y-axis for Conversions */}
          <YAxis
            yAxisId="right"
            orientation="right"
            stroke="#90a4ae"
            fontSize={10}
            fontWeight={300}
            minTickGap={1}
            tickFormatter={formatCurrency}
            axisLine={false}
            tickLine={false}
            label={{
              value: "Conversions",
              angle: -90,
              position: "insideRight",
              style: { fill: "#90a4ae", fontSize: 11, fontWeight: 500 },
            }}
          />
          <Tooltip
            contentStyle={{
              borderRadius: 12,
              border: "1px solid #e3f2fd",
              boxShadow: "0 4px 12px rgba(3, 169, 244, 0.12)",
              padding: "10px 14px",
            }}
            formatter={(value, name) => {
              if (name === "Conversions") {
                return [value.toLocaleString(), name];
              }
              return [value, name];
            }}
          />
          <Legend
            verticalAlign="top"
            height={36}
            wrapperStyle={{ paddingBottom: 10 }}
          />

          {/* Bars with left Y-axis (Advertisers and Campaigns) */}
          <Bar
            yAxisId="left"
            dataKey="Advertisers"
            fill="#03a9f4"
            radius={[8, 8, 0, 0]}
          />
          <Bar
            yAxisId="left"
            dataKey="Campaigns"
            fill="#0288d1"
            radius={[8, 8, 0, 0]}
          />
          {/* Conversions bar with right Y-axis */}
          <Bar
            yAxisId="right"
            dataKey="Conversions"
            fill="#81d4fa"
            radius={[8, 8, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};


export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    .see-more2 {
      padding: 10px 16px;
      height: 42px;
      border: 2px solid #e3f2fd;
      border-radius: 10px;
      font-size: 14px;
      font-weight: 500;
      background-color: #ffffff;
      color: #1a237e;
      cursor: pointer;
      transition: all 0.3s ease;
      
      &:focus {
        outline: none;
        border-color: #03a9f4;
        box-shadow: 0 0 0 3px rgba(3, 169, 244, 0.1);
      }
      
      option {
        color: #1a237e;
      }
    }

`
export default Linechart;
